import { Map, List } from 'immutable';
import createSelector from '../../utils/reselect';

const getCitations = (state: any) => {
    const { citation } = state;
    return citation || Map();
};

export const getCitationList = createSelector(getCitations, (state) => {
    return state.getIn(['citationList', 'data']);
});

export const getCitationListLoading = createSelector(getCitations, (state) => {
    return state.getIn(['citationList', 'loading']);
});

export const getLoadMore = createSelector(getCitations, (state) => {
    return state.getIn(['citationList', 'loadMore']);
});

export const getCitationsCount = createSelector(getCitations, (state) => {
    return state.getIn(['citationList', 'citationCount']);
});

export const getCitationDetail = createSelector(getCitations, (state) => {
    return state.getIn(['citationDetail', 'data']);
});

export const getCitationLoading = createSelector(getCitations, (state) => {
    return state.getIn(['citationDetail', 'loading']) || false;
});

export const getCitationEditForm = createSelector(getCitations, (state) => {
    return state.getIn(['citationEditForm', 'editForm']);
});

export const getCitationFileListLoadingStatus = createSelector(getCitations, (state) => {
    return state.getIn(['citationFiles', 'loading']);
});

export const getLoadMoreCitationFile = createSelector(getCitations, (state) => {
    return state.getIn(['citationFiles', 'loadMore']);
});

export const getCitationFilesList = createSelector(getCitations, (state) => {
    return state.getIn(['citationFiles', 'data']) || List();
});

export const getCitationType = createSelector(getCitations, (state) => {
    return state.getIn(['citationType', 'data']) || Map();
});

export const getCitationCommentList = createSelector(getCitations, (state) => {
    return state.getIn(['citationComments', 'data']) || List();
});

export const getLoadMoreCitationCommentList = createSelector(getCitations, (state) => {
    return state.getIn(['citationComments', 'loadMore']);
});

export const getAddCitationCommentLoader = createSelector(getCitations, (state) => {
    return state.getIn(['citationComments', 'loading']);
});

export const getCitationSearchForm = createSelector(getCitations, (state) => {
    return state.getIn(['citationSearchForm', 'data']);
});

export const getCitationSearchFormLoadingStatus = createSelector(getCitations, (state) => {
    return state.getIn(['citationSearchForm', 'loading']);
});

export const getCitationFilterSelections = createSelector(getCitations, (state) => {
    return state.getIn(['citationFilters', 'filterSelections']) || {};
});
